var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qr-bar__logo-avatar"},[_c('v-img',{attrs:{"src":_vm.logoSrcForDisplay,"contain":"","alt":""},on:{"error":_vm.fallbackLogo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }